import { createReducer, } from 'typesafe-actions';

import { fetchCheckoutTerms, } from './actions';

const checkoutTermsInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    errorCode: null,
    data: null,
};

const checkoutTermsReducer = createReducer(checkoutTermsInitialState)
    .handleAction(fetchCheckoutTerms.request, (state,) => ({ ...state, isLoading: true, }))
    .handleAction(fetchCheckoutTerms.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchCheckoutTerms.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload.data?.reason ?? action.payload.message,
        errorCode: action.payload?.code,
    }));

export default checkoutTermsReducer;
